import q from '../../../services/api/Quests';
import b from '../../../services/api/Boards';
import { get_my_crm_boards } from '../../../services/api/Sidequests';
import { classifyQuests } from '../utils';
import { getWebsiteBoardCounts } from '../../crmBoards/boardCounts';

// Compose the original Dailyprofit reads. No source bridge, copy, or migration.
export async function loadCrmBoards(initialQuestId) {
  const responses = await Promise.allSettled([
    q.getMyQuestsForLeads(false), get_my_crm_boards(), b.getStandaloneBoards(),
    q.getServiceQuestLeadCounts(),
  ]);
  const read = index => responses[index].status === 'fulfilled' ? responses[index].value : null;
  const quests = read(0), sidequests = read(1), standalone = read(2), counts = read(3);
  const success = (result, rows) => result && !(result.status >= 400) && Array.isArray(rows);
  const valid = [success(quests, quests?.data?.data), success(sidequests, sidequests?.data?.data), success(standalone, standalone?.data?.boards)];
  if (!valid.some(Boolean)) throw new Error('Could not load CRM boards. Please try again.');

  let health;
  if (valid[0] && quests.data.data.length) {
    try { health = await q.healthCheckQuests(); } catch { /* Optional presentation metadata. */ }
  }
  const groups = classifyQuests(valid[0] ? quests.data.data : [], health?.data?.data || {}, initialQuestId);
  const byId = new Map((Array.isArray(counts?.data?.data) ? counts.data.data : []).map(row => [String(row.questId), row]));
  const boards = [
    ...groups.active,
    ...groups.archived.map(board => ({ ...board, archived: true })),
    ...(valid[1] ? sidequests.data.data : []),
    ...(valid[2] ? standalone.data.boards : []),
  ].map(board => ({ ...board, ...(byId.has(String(board._id)) ? { crmLeadCounts: byId.get(String(board._id)) } : {}) }));
  await Promise.all(boards.filter(board => board.isWebsiteBoard).map(async board => {
    try {
      const response = await b.getBoard(board._id);
      const columns = getWebsiteBoardCounts(response?.data?.board);
      if (columns) board.crmLeadCounts = columns;
    } catch { /* Keep unknown counts unknown; never hide an accessible board. */ }
  }));
  return { status: 200, data: {
    boards: [...new Map(boards.map(board => [String(board._id), board])).values()],
    ...(!valid.every(Boolean) ? { warning: 'Some existing CRM boards could not be loaded. Please try again.' } : {}),
  } };
}
